// 7.1.13 ToObject(argument)
var defined = require('./$.defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/$.to-object.js
// module id = 31
// module chunks = 0